/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Management_Item_2_BodyInputs */

const en_wb_management_item_2_body = /** @type {(inputs: Wb_Management_Item_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`delivery address missing. Operations needs to confirm it.`)
};

const lv_wb_management_item_2_body = /** @type {(inputs: Wb_Management_Item_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trūkst piegādes adreses. Atbildīgajai komandai tā jāapstiprina.`)
};

/**
* | output |
* | --- |
* | "delivery address missing. Operations needs to confirm it." |
*
* @param {Wb_Management_Item_2_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_management_item_2_body = /** @type {((inputs?: Wb_Management_Item_2_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Management_Item_2_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_management_item_2_body(inputs)
	return en_wb_management_item_2_body(inputs)
});